import { render, staticRenderFns } from "./SignInHeading.vue?vue&type=template&id=e8a91b8c&scoped=true"
import script from "./SignInHeading.vue?vue&type=script&lang=js"
export * from "./SignInHeading.vue?vue&type=script&lang=js"
import style0 from "./SignInHeading.vue?vue&type=style&index=0&id=e8a91b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a91b8c",
  null
  
)

export default component.exports